<template>
  <InputNumber
    style="width: 100%;"
    v-model="item.value"
    :placeholder="item.placeholder"
    :disabled="item.disabled"
    :readonly="readonly"
    :min="item.min"
    :max="item.max"
  />
</template>
<script>
import props from './props'
export default {
  name: 'form-item-input',
  mixins: [props],
  data () {
    return {}
  }
}
</script>